import Vue from 'vue';
import filter from './filter.sub';
Vue.filter('capitalize', filter.capitalize);
Vue.filter("filter", filter.filter );
Vue.filter("orderBy", filter.orderBy );
Vue.filter("changelang",filter.changelang);